<ush-modal-map
  class="performance-map"
  *ngIf="!inlineMap() && isOpen()"
  [inlineMap]="false"
  [lat]="perfGroup.cinema.latitude"
  [lng]="perfGroup.cinema.longitude"
  [address]="addressExists(perfGroup)"
  (hide)="onHideMap()"
>
</ush-modal-map>

<ng-container *ngIf="isOpen()">
  <div>
    <!-- CLOSE INLINE MAP -->
    <a
      #closeInlineRef
      class="ush-cinema-close-map"
      *ngIf="inlineMap()"
      style="margin-left: auto"
      (click)="closeInlineMap()"
      (keyup)="keyupCloseInlineMap($event)"
      tabindex="0"
    >
      <fa-icon [icon]="closeIncon" class="map-icon ush-cinema-map-icon"></fa-icon>
    </a>
    <!-- CLOSE INLINE MAP -->
  </div>
  <div class="inlineMap" *ngIf="inlineMap()" [class.hidden]="inlineMap() && isOpen() === false">
    <ush-modal-map
      class="performance-map"
      [inlineMap]="true"
      [lat]="perfGroup.cinema.latitude"
      [lng]="perfGroup.cinema.longitude"
      [address]="addressExists(perfGroup)"
      (hide)="onHideMap()"
    >
    </ush-modal-map>
  </div>
</ng-container>
